import React from 'react';

import {BsArrowUpRight} from 'react-icons/bs'

import {motion} from 'framer-motion'

import { fadeIn } from '../variants'

const services = [
  {
    name: "UI/UX",
    description:" a project with fronend and api integration packages",
    link:'https://github.com/vishesh-hue/watch-hit',
  },
  {
    name: "Web-Dev",
    description:"a fullStack food app with integrated backend and a no sql databse(mongodb)",
    link:'https://github.com/vishesh-hue/VTfood-app',
  },
  {
    name: "Devops",
    description:"multiple scripting projects for a devops life cycle ",
    link:'https://github.com/vishesh-hue/Shell-scripts-DEVOPS-',
  },
  {
    name: "cyber Sequrity",
    description:"a basic spying social engineering tool",
    link:'https://github.com/vishesh-hue/socialEnggspyware',
  }
]
const Services = () => {
  function handle(){
    window.location.href = 'https://www.linkedin.com/in/vishesh-tiwari-a2007b1b9/';
  }
  return (
    <section className='section' id='services'>
        <div className='container mx-auto'>

        <div className='flex flex-col lg:flex-row'>
        <motion.div
        variants={fadeIn('up' ,0.3)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.3}}
        
        className='flex-1 lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0'>
          <h2 className='h2 text-accent mb-6'>
            what Do I Do..
          </h2>
          <h3 className='h3 max-w-[455px] mb-16'>
            I m a freelanceer and currently upskilling myself 
            because learning  never stops
          </h3>
          <button onClick={handle} className='btn btn-sm'> LINKEDIN</button>
        </motion.div>
        <motion.div
        variants={fadeIn('up' ,0.4)}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false , amount: 0.4}}
        className='flex-1'>
          <div>
            {services.map((service , i)=>{
              const {name , description , link} = service;
              return (
              <>
              <div  className='border-b border-white/20 h-[146px] mb-[38px] flex ' key={i}>
                <div className='max-w-[476px]'>
                <h4 className='text-[20px] tracking-wider font-primary font-semibold mb-6'>{name}</h4>
                <p className='font-secondary leading-tight'>{description}</p>
                </div>
                <div className='flex flex-col flex-1 items-end'><a className='btn w-9 h-9 mb-[42px] flex justify-center items-center' href= {link}>
                  <BsArrowUpRight></BsArrowUpRight>
                  </a>
                  <a className='text-gradient text-sm' href={link}>learn more</a>
                  </div>
                </div>
              </>
                
              )
            })}
          </div>

        </motion.div>

        </div>
        </div>

    </section>

  )
  
  
};

export default Services;
